// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.suggestion-item {
    padding: 8px;
    cursor: pointer;
    background-color: white;
    list-style: none;
}
  
.suggestion-item.selected {
    background-color: #f0f0f0;
}
  `, "",{"version":3,"sources":["webpack://./src/MyEditor/SuggestionsDropdown/SuggestionItem.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B","sourcesContent":[".suggestion-item {\n    padding: 8px;\n    cursor: pointer;\n    background-color: white;\n    list-style: none;\n}\n  \n.suggestion-item.selected {\n    background-color: #f0f0f0;\n}\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
